import { render, staticRenderFns } from "./SettlementOrderList.vue?vue&type=template&id=4a672559&scoped=true&lang=pug&"
import script from "./SettlementOrderList.vue?vue&type=script&lang=ts&"
export * from "./SettlementOrderList.vue?vue&type=script&lang=ts&"
import style0 from "./SettlementOrderList.vue?vue&type=style&index=0&id=4a672559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a672559",
  null
  
)

export default component.exports